import { useState } from 'react';
import { createPortal } from 'react-dom';
import { C } from '../styles/tokens.js';

const PALETTE = [C.gold, C.blue, C.green, C.red, C.purple, C.orange];

export default function CardEditPopup({ card, onSave, onDelete, onClose }) {
  const [title, setTitle] = useState(card.title || '');
  const [content, setContent] = useState(card.content || '');
  const [color, setColor] = useState(card.color);

  return createPortal(
    <div onClick={onClose} onMouseDown={e => e.stopPropagation()}
      style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.7)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 99999 }}>
      <div onClick={e => e.stopPropagation()} onMouseDown={e => e.stopPropagation()}
        style={{ background: C.surface, borderRadius: 12, padding: 24, border: `1px solid ${C.border}`, width: 440, boxShadow: '0 24px 64px rgba(0,0,0,0.6)' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
          <div style={{ fontSize: 14, color: C.text, fontWeight: 800 }}>✏ 카드 편집</div>
          <button onClick={onClose} style={{ background: 'transparent', border: 'none', color: C.dim, fontSize: 22, cursor: 'pointer' }}>×</button>
        </div>
        <label style={{ fontSize: 11, color: C.dim, fontWeight: 700 }}>제목</label>
        <input value={title} onChange={e => setTitle(e.target.value)} autoFocus
          onKeyDown={e => { if (e.key === 'Enter') { onSave({ ...card, title, content, color }); }}}
          style={{ width: '100%', padding: '9px 12px', marginTop: 4, marginBottom: 12, background: C.surface2, border: `1px solid ${C.border}`, borderRadius: 6, color: C.text, fontSize: 14, outline: 'none', fontWeight: 700 }} />
        <label style={{ fontSize: 11, color: C.dim, fontWeight: 700 }}>내용</label>
        <textarea value={content} onChange={e => setContent(e.target.value)}
          rows={5}
          style={{ width: '100%', padding: '10px 12px', marginTop: 4, marginBottom: 12, background: C.surface2, border: `1px solid ${C.border}`, borderRadius: 6, color: C.text, fontSize: 13, outline: 'none', resize: 'vertical', fontFamily: 'inherit', lineHeight: 1.6 }} />
        <label style={{ fontSize: 11, color: C.dim, fontWeight: 700 }}>색상</label>
        <div style={{ display: 'flex', gap: 6, marginTop: 6, marginBottom: 18 }}>
          {PALETTE.map(col => (
            <button key={col} onClick={() => setColor(col)}
              style={{ width: 32, height: 32, borderRadius: '50%', background: col, border: color === col ? `2.5px solid ${C.text}` : `1px solid ${C.border}`, cursor: 'pointer' }} />
          ))}
        </div>
        <div style={{ display: 'flex', gap: 6, justifyContent: 'space-between' }}>
          <button onClick={onDelete}
            style={{ padding: '8px 14px', borderRadius: 6, border: `1px solid ${C.red}44`, background: C.redBg, color: C.red, fontSize: 12, cursor: 'pointer', fontWeight: 600 }}>삭제</button>
          <div style={{ display: 'flex', gap: 6 }}>
            <button onClick={onClose}
              style={{ padding: '8px 14px', borderRadius: 6, border: `1px solid ${C.border}`, background: 'transparent', color: C.dim, fontSize: 12, cursor: 'pointer', fontWeight: 600 }}>취소</button>
            <button onClick={() => onSave({ ...card, title, content, color })}
              style={{ padding: '8px 16px', borderRadius: 6, border: 'none', background: C.gold, color: '#000', fontSize: 12, cursor: 'pointer', fontWeight: 700 }}>저장</button>
          </div>
        </div>
      </div>
    </div>,
    document.body
  );
}
